// extracted by mini-css-extract-plugin
module.exports = {"textBlock":"AddressSelected_textBlock__Imgtm"};